<ng-container *ngIf="vo$ | async; let vo">
	<app-panel
		headerHeight="3rem"
		isAlwaysOpen="true"
		hasSearchableGrid="true"
		[hasRefresh]="vo.hasRefresh"
		[actions]="
				vo.mode !== 'STANDALONE' ||
				(vo.mode === 'STANDALONE' &&
				vo.userPermissions.has(ElementPermission.Edit)) ? filterModelActions: []"
		[itemsCount]="vo.filterModelList.elements.size"
		(search)="search($event)"
		(refresh)="refreshFilterModels()">
			<div class="app-panel__title" panel-title>
				<mat-icon [svgIcon]="DcIcons.Filter"></mat-icon>
				<span
					i18n="@@subscription.filterModel.list.title">
					filter-models</span>
			</div>
			<dx-data-grid
				keyExpr="id"
				[elementAttr]="{id: 'subscription-filter-model-list',class: 'app-subscription-filter-model-list'}"
				[dataSource]="vo.filterModelList.elements | toArray"
				[hoverStateEnabled]="true"
				[showColumnHeaders]="true"
				[allowColumnResizing]="true"
				[columnAutoWidth]="false"
				[showRowLines]="false"
				[showColumnLines]="false"
				[rowAlternationEnabled]="false"
				[showBorders]="false"
				[width]="'100%'"
				(onSelectionChanged)="selectFilterModel()"
				(onCellHoverChanged)="onCellHover($event)"
				(onContentReady)="onGridReady()"
				(onRowClick)="onRowClick($event)"
				(onRowPrepared)="onRowPrepared($event)">

				<dxo-load-panel
					shadingColor="rgba(0,0,0,0)"
					[indicatorSrc]="DcLoaders.LoaderInfinite"
					[height]="100"
					[width]="100"
					[enabled]="true"
					[showIndicator]="true"
					[showPane]="true"
					[shading]="true"></dxo-load-panel>

				<dxo-selection
					[mode]="vo.hasSelection ? 'none': 'multiple'"
					showCheckBoxesMode="always"></dxo-selection>

				<!-- Fixable in position columns	-->
				<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

				<ng-container
					*ngFor="let col of vo.filterModelList.availableColumns | toArray">
					<dxi-column
						*ngIf="col.field === 'label'"
						[dataField]="col.field"
						[caption]="col.alias"
						[groupIndex]="col.groupIdx"
						[fixed]="false"
						[allowResizing]="true"
						[allowHiding]="true"
						[allowGrouping]="true"
						[allowSearch]="col.isSearchable"
						[allowFiltering]="col.isFilterable"
						[allowSorting]="true"
						[dataType]="col.type"
						[alignment]="'left'"
						[width]="'40%'"
						[visibleIndex]="col.visibleIndex"
						cellTemplate="labelTemplate"></dxi-column>

					<dxi-column
						*ngIf="col.field === 'description'"
						[dataField]="col.field"
						[caption]="col.alias"
						[groupIndex]="col.groupIdx"
						[fixed]="false"
						[allowResizing]="true"
						[allowHiding]="true"
						[allowGrouping]="true"
						[allowSearch]="col.isSearchable"
						[allowFiltering]="col.isFilterable ?? false"
						[allowSorting]="true"
						[dataType]="col.type"
						[alignment]="'left'"
						[width]="'40%'"
						[visibleIndex]="col.visibleIndex"></dxi-column>

					<dxi-column
						*ngIf="col.field === 'root'"
						[dataField]="col.field"
						[caption]="col.alias"
						[groupIndex]="col.groupIdx"
						[fixed]="false"
						[allowResizing]="true"
						[allowHiding]="true"
						[allowGrouping]="true"
						[allowSearch]="col.isSearchable"
						[allowFiltering]="col.isFilterable ?? false"
						[allowSorting]="false"
						[dataType]="col.type"
						[alignment]="'left'"
						[width]="'40%'"
						[visibleIndex]="col.visibleIndex"
						cellTemplate="queryViewTemplate"></dxi-column>

					<dxi-column
						*ngIf="col.field === 'linkedProfileIds'"
						[dataField]="col.field"
						[caption]="col.alias"
						[groupIndex]="col.groupIdx"
						[fixed]="false"
						[allowResizing]="false"
						[allowHiding]="false"
						[allowGrouping]="false"
						[allowSearch]="col.isSearchable"
						[allowFiltering]="col.isFilterable"
						[allowSorting]="false"
						[alignment]="'left'"
						[width]="90"
						[visibleIndex]="col.visibleIndex"
						cellTemplate="profilesTemplate"></dxi-column>
				</ng-container>

				<dxi-column
					[fixed]="false"
					[allowResizing]="false"
					[allowHiding]="false"
					[allowGrouping]="false"
					[allowSearch]="false"
					[allowSorting]="false"
					[alignment]="'left'"
					[visible]="vo.mode === 'STANDALONE'
						&& vo.userPermissions.has(ElementPermission.Edit)"
					[visibleIndex]="vo.filterModelList.availableColumns.size"
					[width]="70"
					[showInColumnChooser]="false"
					cellTemplate="actionsTemplate"></dxi-column>

				<div *dxTemplate="let cell of 'labelTemplate'" class="label-template">
					<mat-icon
						*ngIf="!cell.data['isInSync'] && vo.subscriptionStatus === SubscriptionStatus.Available"
						matTooltip="My tooltip"
						i18n-matTooltip="@@general.status.not-synced"
						[svgIcon]="DcIcons.NotSynced"></mat-icon>

					<span
						[matTooltip]="cell.data['label']"
						[matTooltipDisabled]="cell.data['label'].length <= 30"
						matTooltipPosition="right">
						{{cell.data['label'] | truncate: 30 : 1 : 'end'}}</span>
				</div>

				<div *dxTemplate="let cell of 'profilesTemplate'">
					<app-overlay-badge
							data-style-override
							class="inactive"
							*ngIf="cell.data['linkedProfileIds'].size !== 0"
							[icon]="ComponentIcons.Profile"
							[value]="cell.data['linkedProfileIds'].size"
							[active]="true"
							[isOpen]="false">
							<app-popover
								overlayContent
								label="projects"
								i18n-label="@@subscription.filterModel.list.column.profiles"
								[icon]="{ iconName: ComponentIcons.Profile }"
								[count]="cell.data['linkedProfileIds'].size">
							</app-popover>
					</app-overlay-badge>
				</div>

				<div *dxTemplate="let cell of 'queryViewTemplate'">
					<app-overlay-badge
						id="{{cell.data['id']}}-query-view-overlay"
						[active]="true"
						[icon]="ComponentIcons.View"
						[isOpen]="vo.openedOverlayFilterModel.filterModelId === cell.key"
						(overlayDismiss)="closeQueryViewOverlay()"
						(click)="openQueryViewPopover($event, cell.key)">
							<app-popover
								id="{{cell.data['id']}}-query-view-popover"
								overlayContent
								label="query-view"
								i18n-label="@@subscription.filterModel.list.column.query-view"
								[icon]="{ iconName: ComponentIcons.View}"
								(adbPopoverClose)="closeQueryViewOverlay()">
								<dcds-query-view
									[fields]="vo.availableFields"
									[query]="cell.data['root']"></dcds-query-view>
							</app-popover>
					</app-overlay-badge>
				</div>

				<div
					*dxTemplate="let cell of 'actionsTemplate'"
					[hidden]="cell.rowIndex !== currentlyHovered">
					<div class="filters-actions-template">
						<button
							mat-icon-button
							class="filters-actions-template__menu-btn"
							matTooltip="update"
							i18n-matTooltip="@@subscription.columnModel.list.action.update"
							matTooltipPosition="left"
							(click)="updateFilterModel(cell.data)">
							<mat-icon [svgIcon]="ActionIcons.Update"></mat-icon>
						</button>

						<button
							mat-icon-button
							class="filters-actions-template__menu-btn"
							matTooltip="delete"
							i18n-matTooltip="@@subscription.filterModel.list.action.delete"
							matTooltipPosition="left"
							(click)="deleteFilterModel(cell.data)">
							<mat-icon [svgIcon]="ActionIcons.Delete"></mat-icon>
						</button>
					</div>
				</div>

				<!-- Sorting	-->
				<dxo-sorting mode="multiple"></dxo-sorting>

				<!-- Pagination -->
				<dxo-paging [pageSize]="10"></dxo-paging>

				<dxo-pager [visible]="true"></dxo-pager>

				<!-- Filterable columns	-->
				<dxo-header-filter [visible]="true"></dxo-header-filter>

				<dxo-filter-row [visible]="true"></dxo-filter-row>

			</dx-data-grid>
	</app-panel>
</ng-container>
